import { LocalStorageKeys } from '@/constants/LocalStorageKeys';
import AuthTokenService from '@/services/AuthTokenService';
import ServiceHelperFactory from '@/services/2.6/ServiceHelperFactory';
import TheWebEnvConfigService from '@/services/TheWebEnvConfigService';
import DateTimeUtils from '@/utils/DateTimeUtils';
import HostUtils from '@/utils/HostUtils';
import theLocalStorageUtils from '@/utils/LocalStorageUtils';

/**
 * Manages obtaining and refreshing the QuickSource auth token data. There are different
 * methods based upon the host application.
 */
export default {
    /**
     * Get a QS auth token and save it to local storage. Depends on the host for how we go
     * about getting the token.
     * @returns
     */
    async getAndSave(): Promise<boolean> {
        const serviceHelper = ServiceHelperFactory.getHelper();
        const success = await serviceHelper.getAndSaveAuthToken();
        return success;
    },

    /**
     * Refresh the QS auth token using the refresh token and save it to local storage.
     * Upon failure will fallback to getting a new auth token.
     * @returns
     */
    async refreshAndSave(): Promise<boolean> {
        if (HostUtils.isTotal() || HostUtils.isNone()) {
            const webConfig = await TheWebEnvConfigService.getInstance().getConfigByHost();
            const refreshToken = theLocalStorageUtils.get(LocalStorageKeys.qsRefreshToken);

            const service = new AuthTokenService(webConfig);
            //service.setLogRequest(true);

            const tokenData = await service.refreshPassQuickSource(refreshToken ?? '');
            if (tokenData) {
                theLocalStorageUtils.saveTokenData(tokenData);

                const durationMins = DateTimeUtils.getMinutesFromNow(tokenData.expires ?? '');
                //console.log(`AuthTokenManager.refreshAndSave(), From service, Expiration[${tokenData.expires}], minutes[${durationMins?.minutes}]`);
                return true;
            } else {
                // Refresh failed, attempt a get and save
                //console.log(`AuthTokenManager.refreshAndSave(), Failed, Attempting to get a new access token.`);
                return await this.getAndSave();
            }
        } else {
            const productId = theLocalStorageUtils.get(LocalStorageKeys.callingProductId);
            console.log(`AuthTokenManager.refreshAndSave(), Unknown host type[${productId}]`);
        }

        return false;
    }
};
